<template>
<svg viewBox="0 0 48 48" :fill="useCurrentColor ? 'currentColor' : 'currentColor'" :class="[`${prefix}-icon`, `${prefix}-icon-door`]" width="1em" height="1em" v-bind="$attrs"><path fill-rule="evenodd" clip-rule="evenodd" d="M16 26v-5a1 1 0 011-1h2a1 1 0 011 1v5a1 1 0 01-1 1h-2a1 1 0 01-1-1zM9.762 2h28.476C39.211 2 40 2.658 40 3.47v41.06c0 .812-.789 1.47-1.762 1.47H9.762C8.789 46 8 45.342 8 44.53V3.47C8 2.659 8.789 2 9.762 2zM12 6v36h24V6H12z"/></svg>
</template>
<script>

export default {
  name: 'IconDoor',
  props: {
    prefix: {
        type: String,
        default: 'm',
    },
    useCurrentColor: {
        type: Boolean,
        default: false,
    },
  },
};
</script>
